import React, {createContext, useId} from 'react';

import PopupSticked from '@/components/Popup/PopupSticked';
import {twx} from '@/utils/tailwindUtils';

const LoyaltyPopupContext = createContext(null);

const LoyaltyModalPopup = ({className, children, ...props}) => {
    const headerId = useId();

    return (
        <LoyaltyPopupContext.Provider value={{headerId}}>
            <PopupSticked
                isCloseVisible={false}
                aria-labelledby={headerId}
                className={twx(
                    'w-full rounded-t-xl bg-primary-dark px-6 py-8 ml:max-w-[457px] ml:rounded-[32px] ml:px-6 ml:py-8',
                    className
                )}
                {...props}
            >
                {children}
            </PopupSticked>
        </LoyaltyPopupContext.Provider>
    );
};

export default LoyaltyModalPopup;
